import { render, staticRenderFns } from "./business-modal.vue?vue&type=template&id=a3b13022&scoped=true&"
import script from "./business-modal.vue?vue&type=script&lang=js&"
export * from "./business-modal.vue?vue&type=script&lang=js&"
import style0 from "./business-modal.vue?vue&type=style&index=0&id=a3b13022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b13022",
  null
  
)

export default component.exports